/**
 * @typedef {Object} ReturnRequestSummaryPageData
 * @property {boolean} devMode
 * @property {string} token
 * @property {string} returnTypeText
 * @property {string} exchangeTypeText
 * @property {string} warrantyTypeText
 */

const returnRequestSummaryPageData = /** @type {ReturnRequestSummaryPageData} */ (
    JSON.parse(
        document.getElementById("return-exchange-wrarranty-page-data")?.textContent ?? "{}"
    )
);

const returnRequestTypeSpan = /** @type {HTMLElement}*/ (document.getElementById('return-request-type-span'));

const returnRequestFirstNameEl = /** @type {HTMLElement}*/ (document.getElementById('return-request-first-name'));
const returnRequestLastNameEl = /** @type {HTMLElement}*/ (document.getElementById('return-request-last-name'));
const returnRequestAddressEl = /** @type {HTMLElement}*/ (document.getElementById('return-request-address'));
const returnRequestPhoneEl = /** @type {HTMLElement}*/ (document.getElementById('return-request-phone'));

const returnTemplate = /** @type {HTMLElement}*/ (document.getElementById('article-return-template'));
const exchangeTemplate = /** @type {HTMLElement}*/ (document.getElementById('article-exchange-template'));
const warrantyTemplate = /** @type {HTMLElement}*/ (document.getElementById('article-warranty-template'));
const articleLstWrapper = /** @type {HTMLElement}*/ (document.getElementById('article-list-wraper'));

const statusLstWrapper = /** @type {HTMLElement}*/ (document.getElementById('status-list-wrapper'));
const statusTemplate = /** @type {HTMLElement}*/ (document.getElementById('status-template'));
const statusSeparatorTemplate = /** @type {HTMLElement}*/ (document.getElementById('status-separator-template'));

const returnRequestSummaryWebReturnRequestApi = getDivZeroWebPublicApi(DivZeroWebPublicApi.WebReturnRequestApi, false);

(async () => {
    if (returnRequestSummaryPageData.token !== '' && returnRequestSummaryPageData.token !== 'token') {
        await tryGetReturnRequest(returnRequestSummaryPageData.token);
    } else {
        siteLoader.hide();
        document.getElementById("no-return-request-wrapper")?.classList.remove('d-none');
        document.getElementById("return-request-summary-wrapper")?.classList.add('d-none');
    }
})();

/**
 * 
 * @param {String} token 
 */
async function tryGetReturnRequest(token) {
    try {
        siteLoader.show();

        const response = await returnRequestSummaryWebReturnRequestApi.webReturnRequestGetWebReturnRequestByToken({
            token: token,
            //The generated client types this as a Set but its serialization calls .map() on it, so it
            //must be an array at runtime. Cast to any to satisfy the (incorrect) Set parameter type.
            divZeroWebApiDomainNswagApiModelsDivZeroWebApiModelsWebReturnRequestIncludeEnum: /** @type {any} */ ([
                //Shipping Address
                6,
                //Active Items
                9,
                //ALL Statuses
                16,
                //Active Type
                17
            ])
        });

        if (!response) throw ("Missing or invalid token");

        setupPage(response);

    }
    catch (error) {
        console.log(error);
        document.getElementById("no-return-request-wrapper")?.classList.remove('d-none');
        document.getElementById("return-request-summary-wrapper")?.classList.add('d-none');
    } finally {
        siteLoader.hide();
    }
}

/**
 * 
 * @param {DivZeroWebPublicModels.WebReturnRequest} returnRequest 
 */
function setupPage(returnRequest) {
    const imageSrcTemplate = "//royer.com/cdn/shop/files/{reference}_SIDE.jpg";
    const imageSrcTemplateOldUrlFallback = "https://cdn.shopify.com/s/files/1/0569/8197/9308/products/{reference}_SIDE.jpg";
    const typeEnum = returnRequest.types?.at(0)?.type;
    let typeArchetype;

    switch (typeEnum) {
        case 0: case 1:
            typeArchetype = "RETURN";
            break;
        case 2: case 3:
            typeArchetype = "EXCHANGE";
            break;
        case 4: case 5: case 6: case 7:
            typeArchetype = "WARRANTY";
            break;
        default:
            typeArchetype = "";
    }

    let requestTypeText = "";
    if (typeArchetype == "RETURN") requestTypeText = returnRequestSummaryPageData.returnTypeText;
    else if (typeArchetype == "EXCHANGE") requestTypeText = returnRequestSummaryPageData.exchangeTypeText;
    else if (typeArchetype == "WARRANTY") requestTypeText = returnRequestSummaryPageData.warrantyTypeText;

    returnRequestTypeSpan.innerText = requestTypeText;

    returnRequestFirstNameEl.innerText = returnRequest.shpAdr?.firstName ?? "";
    returnRequestFirstNameEl.innerText = returnRequest.shpAdr?.lastName ?? "";

    let address = "";
    if (returnRequest.shpAdr?.local) address += returnRequest.shpAdr.local + "-";
    address += returnRequest.shpAdr?.street + ", " + returnRequest.shpAdr?.city + ", " + returnRequest.shpAdr?.regionCode + ", " + returnRequest.shpAdr?.postalCode;

    returnRequestAddressEl.innerText = address;
    returnRequestPhoneEl.innerText = returnRequest.shpAdr?.phoneNb ?? "";

    const items = [...returnRequest.items ?? []];

    const itemsComingIn = items.filter(item => item.direction == 1);
    const itemsComingOut = items.filter(item => item.direction == 2);

    itemsComingIn.forEach(comingInItem => {
        const goingOutItemIdx = itemsComingOut.findIndex(item => item.direction == 2 && item.sourceMouvementNb == comingInItem.sourceMouvementNb);
        if (goingOutItemIdx != -1) {
            const goingOutItem = itemsComingOut[goingOutItemIdx];
            itemsComingOut.splice(goingOutItemIdx, 1);

            const exchangeWrapper = /** @type {HTMLElement}*/ (exchangeTemplate.cloneNode(true));
            exchangeWrapper.id = "";
            exchangeWrapper.classList.remove("d-none");

            const comingInEl = /** @type {HTMLElement}*/ (exchangeWrapper.querySelector(".coming-in"));

            const comingInImgEl = /** @type {HTMLImageElement}*/ (comingInEl.querySelector(".article-img"));
            comingInImgEl.src = imageSrcTemplate.replace("{reference}", comingInItem.article?.ref ?? "");
            comingInImgEl.onerror = () => {
                comingInImgEl.onerror = null;
                comingInImgEl.src = imageSrcTemplateOldUrlFallback.replace("{reference}", comingInItem.article?.ref ?? "");
            };
            const comingInArticleRefEl = /** @type {HTMLElement}*/ (comingInEl.querySelector(".article-ref"));
            comingInArticleRefEl.innerText = [comingInItem.article?.ref ?? "", comingInItem.article?.sref1 ?? "", comingInItem.article?.sref2 ?? ""].filter(Boolean).join("-")

            const goingOutEl = /** @type {HTMLElement}*/ (exchangeWrapper.querySelector(".going-out"));

            const goingOutImgEl = /** @type {HTMLImageElement}*/ (goingOutEl.querySelector(".article-img"));
            goingOutImgEl.src = imageSrcTemplate.replace("{reference}", goingOutItem.article?.ref ?? "");
            goingOutImgEl.onerror = () => {
                goingOutImgEl.onerror = null;
                goingOutImgEl.src = imageSrcTemplateOldUrlFallback.replace("{reference}", goingOutItem.article?.ref ?? "");
            };
            const goingOutArticleRefEl = /** @type {HTMLElement}*/ (goingOutEl.querySelector(".article-ref"));
            goingOutArticleRefEl.innerText = [goingOutItem.article?.ref ?? "", goingOutItem.article?.sref1 ?? "", goingOutItem.article?.sref2 ?? ""].filter(Boolean).join("-")

            articleLstWrapper.append(exchangeWrapper);
        }
        else {
            const returnWrapper = /** @type {HTMLElement}*/ (returnTemplate.cloneNode(true));
            returnWrapper.id = "";
            returnWrapper.classList.remove("d-none");

            const comingInEl = /** @type {HTMLElement}*/ (returnWrapper.querySelector(".coming-in"));

            const comingInImgEl = /** @type {HTMLImageElement} */ (comingInEl.querySelector(".article-img"));
            comingInImgEl.src = imageSrcTemplate.replace("{reference}", comingInItem.article?.ref ?? "");
            comingInImgEl.onerror = () => {
                comingInImgEl.onerror = null;
                comingInImgEl.src = imageSrcTemplateOldUrlFallback.replace("{reference}", comingInItem.article?.ref ?? "");
            };
            const comingInArticleRefEl = /** @type {HTMLElement} */ (comingInEl.querySelector(".article-ref"));
            comingInArticleRefEl.innerText = [comingInItem.article?.ref ?? "", comingInItem.article?.sref1 ?? "", comingInItem.article?.sref2 ?? ""].filter(Boolean).join("-");

            articleLstWrapper.append(returnWrapper);
        }
    });

    itemsComingOut.forEach(goingOutItem => {
        const warrantyWrapper = /** @type {HTMLElement}*/ (warrantyTemplate.cloneNode(true));
        warrantyWrapper.id = "";
        warrantyWrapper.classList.remove("d-none");

        const goingOutEl = /** @type {HTMLElement}*/ (warrantyWrapper.querySelector(".going-out"));

        const goingOutImgEl = /** @type {HTMLImageElement}*/ (goingOutEl.querySelector(".article-img"));
        goingOutImgEl.src = imageSrcTemplate.replace("{reference}", goingOutItem.article?.ref ?? "");
        goingOutImgEl.onerror = () => {
            goingOutImgEl.onerror = null;
            goingOutImgEl.src = imageSrcTemplateOldUrlFallback.replace("{reference}", goingOutItem.article?.ref ?? "");
        };
        const goingOutArticleRefEl = /** @type {HTMLElement} */ (goingOutEl.querySelector(".article-ref"));
        goingOutArticleRefEl.innerText = [goingOutItem.article?.ref ?? "", goingOutItem.article?.sref1 ?? "", goingOutItem.article?.sref2 ?? ""].filter(Boolean).join("-");

        articleLstWrapper.append(warrantyWrapper);
    });

    let firstStatus = true;
    returnRequest.statuses?.reverse().forEach(status => {

        const statusWrapper = /** @type {HTMLElement} */ (statusTemplate.cloneNode(true));
        statusWrapper.id = "";
        statusWrapper.classList.remove("d-none");

        const statusDateEl = /** @type {HTMLElement} */ (statusWrapper.querySelector(".status-date"));
        const statusTypeEl = /** @type {HTMLElement} */ (statusWrapper.querySelector(".status-type"));
        statusDateEl.innerText = formatDateTime(status.createdOn ?? new Date());
        const statusTextEl = /** @type {HTMLElement | null}*/(document.querySelector(`.status-text[data-status="${status.status}"]`));
        if (statusTextEl) statusTypeEl.innerText = statusTextEl.innerText;

        const descriptionEl = /** @type {HTMLElement}*/ (statusWrapper.querySelector(".status-description"));
        const statusDescEl = /** @type {HTMLElement | null}*/ (document.querySelector(`.status-desc[data-status="${status.status}"]`));
        if (statusDescEl)  descriptionEl.innerText = statusDescEl.innerText;
        if (status.status == 1) descriptionEl.innerText += status.reason

        if (!firstStatus) {
            const statusSeparator = /** @type {HTMLElement}*/ (statusSeparatorTemplate.cloneNode(true));
            statusSeparator.id = "";
            statusSeparator.classList.remove("d-none");
            statusLstWrapper.append(statusSeparator);
        }
        statusLstWrapper.append(statusWrapper);

        firstStatus = false;
    });
}

/**
 * 
 * @param {Date} input 
 * @returns 
 */
function formatDateTime(input) {
    const yyyy = input.getFullYear();
    const mm = String(input.getMonth() + 1).padStart(2, "0");
    const dd = String(input.getDate()).padStart(2, "0");

    let hours = input.getHours();
    const minutes = String(input.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const hh = String(hours).padStart(2, "0");

    return `${yyyy}-${mm}-${dd} ${hh}:${minutes} ${ampm}`;
}